/**
 * Compacte bedragen voor statusregels (feedback Asil 2 oktober 2026: "€300k"-formaat, zodat de status naast de
 * titel past). Alleen voor samenvattingen; tabellen en het dossier tonen het bedrag voluit.
 *
 *   950 → "€950" · 12.480 → "€12,5k" · 156.832 → "€157k" · 2.345.678 → "€2,3 mln" · −6.095 → "−€6,1k"
 */

export function compactEuro(n: number): string {
  if (!isFinite(n)) return "€–";
  const sign = n < 0 ? "−" : "";
  const a = Math.abs(n);
  const nl = (v: number, digits: number): string =>
    v.toLocaleString("nl-NL", { minimumFractionDigits: 0, maximumFractionDigits: digits });
  if (a < 1000) return `${sign}€${nl(Math.round(a), 0)}`;
  if (a < 1e6) {
    const k = a / 1000;
    return `${sign}€${nl(k < 100 ? Math.round(k * 10) / 10 : Math.round(k), k < 100 ? 1 : 0)}k`;
  }
  const m = a / 1e6;
  return `${sign}€${nl(m < 100 ? Math.round(m * 10) / 10 : Math.round(m), m < 100 ? 1 : 0)} mln`;
}

/** Een NL-geformatteerd bedrag ("€ 156.832", "€ -6.095,37", "€ 1.234,56") in een tekst. */
// Een bedrag dat al kort is ("€1,8k", "€2,3 mln") blijft staan: anders werd "€1,8k" opnieuw afgerond tot "€2k".
const EURO_IN_TEXT = /€\s?(-?\d{1,3}(?:\.\d{3})*(?:,\d+)?|-?\d+(?:,\d+)?)(?![\d.,]|k|\s?mln)/g;

/** Vervangt alle bedragen in een statustekst door hun compacte vorm. */
export function compactEurosInText(text: string): string {
  return text.replace(EURO_IN_TEXT, (_m, num: string) =>
    compactEuro(Number(num.replace(/\./g, "").replace(",", ".")))
  );
}
